import { render, staticRenderFns } from "./CompAccordionItem.vue?vue&type=template&id=40731e84&scoped=true"
import script from "./CompAccordionItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CompAccordionItem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompAccordionItem.vue?vue&type=style&index=0&id=40731e84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40731e84",
  null
  
)

export default component.exports